import { useEffect } from 'react';

import { closeSnackbar, SnackbarProvider } from 'notistack';

const NotistackSnackbarProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  useEffect(() => {
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeSnackbar();
      }
    };

    window.addEventListener('keydown', handleKey);
    return () => {
      window.removeEventListener('keydown', handleKey);
    };
  }, []);

  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      preventDuplicate
    >
      {children}
    </SnackbarProvider>
  );
};

export default NotistackSnackbarProvider;
